import type { Account } from '@adtrackify/at-tracking-event-types';
import type { QueryClient } from '@tanstack/react-query';
import type { AxiosResponse } from 'axios';

import { accountKeys } from '@/features/workspace/api/account-keys';
import type { AccountListResponse } from '@/services/internal-api/accounts/types/accounts-api-service-types';

export function updateAccountInCache(queryClient: QueryClient, account: Account): void {
  queryClient.setQueryData<AxiosResponse<AccountListResponse>>(accountKeys.list(), previous => {
    if (!previous?.data?.accounts) {
      return previous;
    }

    return {
      ...previous,
      data: {
        ...previous.data,
        accounts: previous.data.accounts.map(item => (item.id === account.id ? account : item)),
      },
    };
  });
}
